import Vue from 'vue'
import Vuex from 'vuex'
import { apiBehaviorLog, getParams, createMask } from './mainDian'
import { getNativeConfig, notifyNative, noticeHarmony } from './native'
import { getLocalData } from '@/config/utils'
import { getFullPathname } from '@/config/app-base-path'

Vue.use(Vuex)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    _userInfo: getLocalData('userInfo') || {}
  },
  getters: {
    userInfo (state) {
      return state._userInfo || {}
    },
    lzCode (state, getters) { // 渠道code
      return localStorage.getItem('lzCode') || ''
    },
    envData () {
      return localStorage.getItem('envData') ? JSON.parse(Vue.prototype.$base64.decode(localStorage.getItem('envData'))) : {}
    },
    mdData (state, getters) {
      const result = {
        VERSION: '', // 版本号
        DEV_ID: '', // 设备标识
        LZ_CODE: getters.lzCode, // 渠道code
        DEVICE_OS: Vue.prototype.$getOsFrom() === 'ios' ? 'h5_ios' : 'h5_and', // 操作系统
        USER_ID: getters.userInfo.userId,
        UNIQUE_CODE: getters.userInfo.uniqueCode
      }
      if (getters.appInfo) {
        result.VERSION = getters.appVersion
        result.DEV_ID = getters.envData.devId
      }
      return result
    }
  },
  mutations: {
    SET_USER_INFO (state, userInfo) {
      state._userInfo = userInfo || {}
    }
  },
  actions: {
    async point ({ getters }, { type, url, product = {}, mask, urlParams }) {
      if (mask) {
        await createMask(Vue)
      }
      const config = getParams(type)
      if (!config) return
      const newProduct = Object.keys(product).reduce((data, key) => {
        const val = product[key]
        key = key.replace(/([a-z]+)([a-zA-Z]?)/g, (a, b, c) => {
          let res = b.toUpperCase()
          if (c) {
            res = `${res}_${c.toUpperCase()}`
          }
          return res
        })
        data[key] = val
        return data
      }, {})
      console.warn('----- my data is newProduct: ', newProduct)
      // 公共埋点字段为空时不参与合并，避免覆盖页面从 query 显式传入的 USER_ID 等字段。
      const mdCommonData = Object.keys(getters.mdData).reduce((data, key) => {
        if (getters.mdData[key] !== undefined) {
          data[key] = getters.mdData[key]
        }
        return data
      }, {})
      console.warn('----- my data is mdCommonData: ', mdCommonData)
      const mdData = JSON.stringify(Object.assign(config, newProduct, mdCommonData, {
        supplierCode: getLocalData('category'), // 资方code
        irr: getLocalData('irr') // 银行利率
      }))
      if (Object.keys(newProduct).length === 0) {
        return new Promise(resolve => {
          try {
            apiBehaviorLog(mdData, getters.mdPackage)
          } catch (error) {
            console.log(error)
          }
          if (url) {
            this.dispatch('native', { type: '打开webview', urlParams: { url, ...{ type: '', title: '', productId: '' }, ...urlParams } }).then(() => {
              resolve()
            }).catch(() => {
              const index = url.indexOf('/unicom/')
              const targetUrl = index >= 0
                ? getFullPathname(url.slice(index + '/unicom'.length))
                : url
              location.href = targetUrl
            })
          } else {
            resolve()
          }
        })
      }
      if (url) {
        return apiBehaviorLog(mdData, getters.mdPackage).then(() => {
          this.dispatch('native', { type: '打开webview', urlParams: { url, ...{ type: '', title: '', productId: '' }, ...urlParams } }).catch(() => {
            const index = url.indexOf('/unicom/')
            const targetUrl = index >= 0
              ? getFullPathname(url.slice(index + '/unicom'.length))
              : url
            location.href = targetUrl
          })
        })
      } else {
        return apiBehaviorLog(mdData, getters.mdPackage)
      }
    }
  },
  modules: {
    app: {
      getters: {
        appInfo () {
          return getLocalData('appInfo') || {}
        },
        envParams () {
          try {
            return JSON.parse(Vue.prototype.$base64.decode(decodeURIComponent(localStorage.getItem('envData'))))
          } catch (e) {
            return {}
          }
        },
        appVersion (state, getters) {
          return getters.appInfo.appVersion || ''
        },
        devOS (state, getters) {
          const devOS = getters.envParams.devOS
          if (devOS) {
            const match = devOS.match(/^(and|ios)/i)
            if (match) {
              return match[1].toLowerCase()
            }
          } else {
            return Vue.prototype.$getOsFrom() === 'ios' ? 'ios' : 'and'
          }
        },
        platform (state, getters) {
          const devOS = getters.devOS
          const plats = ['harm']
          if (devOS === 'and') {
            const result = plats.find(item => {
              return navigator.userAgent.toLowerCase().includes(item)
            })
            return result || 'and'
          }
        },
        // 客户端协议及区分pkgName包名字段专用
        pkg (state, getters) {
          const appInfo = getters.appInfo
          const app = appInfo.pkgName || (appInfo.appVersion ? 'sd' : '')
          if (app.startsWith('APP_')) {
            return app.slice(4).toLowerCase()
          }
          return app
        },
        // 资源位接口package字段专用
        resourcePkgName (state, getters) {
          if (['yjd', 'yjsd', 'sd'].includes(getters.pkg) || !getters.appVersion) return ''
          else return getters.pkg + '_'
        },
        // 埋点接口package字段专用
        mdPackage (state, getters) {
          const appInfo = getters.appInfo
          let app
          if (Object.keys(appInfo).length) {
            if (appInfo.pkgName) {
              app = appInfo.pkgName === 'APP_YJSD' ? 'APP_YJD' : appInfo.pkgName
            } else {
              app = 'APP_YJD'
            }
          } else {
            app = getters.lzCode
          }
          return app
        },
        nativeConfig (state, getters) {
          const { appVersion, pkg, devOS, appInfo } = getters
          if (!pkg) {
            return {}
          }
          if (!appVersion) return {}
          let newPkg = pkg
          if (['yjd', 'yjsd'].includes(newPkg)) newPkg = 'sd'
          const result = getNativeConfig(newPkg, devOS, appVersion, appInfo.channel === 'harmony')
          return result
        }
      },
      actions: {
        native ({ getters }, { type, urlParams }) {
          return new Promise((resolve, reject) => {
            const { nativeConfig, appVersion, pkg, devOS, appInfo } = getters
            const config = nativeConfig[type]
            if (!config) {
              console.warn(`${type} 没有被配置，或者此${pkg + '_' + devOS + '_' + appVersion}版本没有此协议`)
              console.warn('此版本支持的协议有：', Object.keys(nativeConfig))
              return reject(new Error(`${type} 没有被配置，或者此${pkg + '_' + devOS + '_' + appVersion}版本没有此协议`))
            }
            if (appInfo.channel === 'harmony') {
              noticeHarmony(type, config, urlParams, resolve, reject)
            } else {
              notifyNative(Vue, config, urlParams, resolve)
            }
          })
        }
      }
    }
  }
})

export default store
